import React, { ReactElement, ReactNode, useMemo } from 'react';
import { Group } from 'types/groupService';
import { observer } from 'mobx-react-lite';
import { HorizontalTabBarStyled } from './styles';

interface Props {
  groups: Group[];
  activeGroupId: string;
  onSelectGroup: (group: Group) => void;
  children: ReactNode;
}

const GroupTabSwitcher: React.FC<Props> = observer(({ groups, activeGroupId, onSelectGroup, children }) => {
  if (groups.length <= 1) {
    return children;
  }

  const tabs = useMemo(
    () =>
      groups.map((group) => ({
        id: group.id,
        label: group.name,
      })),
    [groups],
  );

  const setActiveTab = (groupId: string): void => {
    if (groupId !== activeGroupId) {
      onSelectGroup(groups.find((group) => group.id === groupId)!);
    }
  };

  return (
    <HorizontalTabBarStyled tabs={tabs} activeTabId={activeGroupId} setActiveTab={setActiveTab}>
      {children as ReactElement}
    </HorizontalTabBarStyled>
  );
});

export default GroupTabSwitcher;
